// Registers the service worker so app can work offline

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register() {
  if (!("serviceWorker" in navigator)) return;

  const base = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const swUrl = `${base}/service-worker.js`;

  if (isLocalhost) {
    window.addEventListener("load", () => checkValidServiceWorker(swUrl));
    return;
  }

  // Register immediately in production so Chrome can offer "Install app" sooner.
  registerValidSW(swUrl);
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      console.log("Service Worker registered: ", registration);
    })
    .catch((error) => {
      console.error("Error during service worker registration:", error);
    });
}

function checkValidServiceWorker(swUrl) {
  fetch(swUrl)
    .then((response) => {
      if (
        response.status === 404 ||
        response.headers.get("content-type").indexOf("javascript") === -1
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister();
        });
      } else {
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log("No internet connection. App is running offline.");
    });
}
